export default {
  // 2-14
  GET_CSTCHOICE_LIST(state, res) {
    const data = JSON.parse(JSON.stringify(res.data));
    data.forEach((e, index) => {
      e.index = index + 1;
    });
    state.cst_choicelist = data;
  },
  GET_CSTAPPLIER_DATA(state, res) {
    const data = JSON.parse(JSON.stringify(res.data));
    data.forEach((e, index) => {
      e.index = index + 1;
      e.create_date = e.create_Date.substr(0, 10);
      e.personInfo = `${e.p_Name}(${e.sex})${e.id}`;
      e.period = `${e.insurance_Begin}~${e.insurance_End}`;
      e.approve_Status2 = e.approve_Status;
    });
    state.cst_applier = data;
    state.cst_applierlist = state.cst_applier.slice(0, 10);
  },

  // 2-15
  GET_CSTCENSOR_DATA(state, res) {
    const data = JSON.parse(JSON.stringify(res.data));
    data.forEach((e, index) => {
      e.index = index + 1;
      e.create_date = e.create_Date.substr(0, 10);
      e.personInfo = `${e.p_Name}(${e.sex})${e.id}`;
    });
    state.cst_forcensor = data;
    state.cst_forcensorlist = state.cst_forcensor.slice(0, 10);
  },
};
